import { Component, type ErrorInfo, type ReactNode } from "react";
import { Button, Callout } from "../shared/ui/Primitives";

interface State { error: Error | null; }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Unhandled UI error", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="fatal-screen">
        <div className="fatal-screen__card">
          <h1>Интерфейс не смог продолжить работу</h1>
          <Callout tone="danger">{this.state.error.message}</Callout>
          <Button onClick={() => window.location.reload()} icon="refresh">Перезагрузить</Button>
        </div>
      </main>
    );
  }
}
